import { render, staticRenderFns } from "./patrolPerson.vue?vue&type=template&id=0bac4ac8"
import script from "./patrolPerson.vue?vue&type=script&lang=js"
export * from "./patrolPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bac4ac8')) {
      api.createRecord('0bac4ac8', component.options)
    } else {
      api.reload('0bac4ac8', component.options)
    }
    module.hot.accept("./patrolPerson.vue?vue&type=template&id=0bac4ac8", function () {
      api.rerender('0bac4ac8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/patrol/patrolPerson.vue"
export default component.exports